<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    ref="outstanding_draws_datatable"
    :title="`Outstanding ${intervalNamePlural}`"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { mapState } from "vuex";

import Badge from "@/components/Badge.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      },
      intervalName({ tenant }) {
        return (
          tenant?.feature_flags?.progress_billing_interval_name || "Installment"
        );
      },
      intervalNamePlural({ tenant }) {
        return (
          tenant?.feature_flags?.progress_billing_interval_name_plural ||
          `${
            tenant?.feature_flags?.progress_billing_interval_name ||
            "Installment"
          }s`
        );
      }
    }),
    config() {
      // The secondary sort is by position, so it moves with the classification
      // columns to stay on the same column.
      const classificationColumns = customerClassificationColumns();

      return {
        responsive: true,
        order: [
          [0, "asc"],
          [6 + classificationColumns.length, "asc"]
        ],
        language: {
          emptyTable: `There are currently no outstanding ${this.intervalNamePlural.toLowerCase()}.`
        },
        columns: [
          {
            data: "status_rank",
            title: "",
            visible: false,
            searchable: false,
            responsivePriority: 9
          },
          ...classificationColumns,
          {
            data: "customer",
            aggregateTitle: "Customers",
            responsivePriority: 1
          },
          { data: "job", title: "Job #", responsivePriority: 6 },
          { data: "invoice", title: "Invoice #", responsivePriority: 2 },
          {
            data: "draw_name",
            title: `${this.intervalName} Name`,
            responsivePriority: 7
          },
          {
            data: "draw_amount",
            title: `${this.intervalName} Amount`,
            className: "text-right",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "due_date",
            title: "Due Date",
            searchable: false,
            responsivePriority: 5
          },
          {
            data: "due_status",
            title: "Status",
            filterName: "due_status",
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "department",
            title: "Department",
            filterName: "department_id",
            searchable: false,
            responsivePriority: 8
          }
        ],
        vueComponents: [
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Outstanding Draws" });
  }
};
</script>
